import {Component} from '@angular/core';
import {routeAnimations} from "../shared/animations/router-animation";

@Component({
  selector: 'app-page',
  templateUrl: './page.component.html',
  styleUrl: './page.component.scss',
  animations: [routeAnimations]
})
export class PageComponent {

}
